export const verifyAvailableLicenseState = {
  availableLicense: false,
  loading: false,
  error: null,
  errorShow: false,
  getData: false,
};
